'use client';

import { forwardRef } from 'react';
import type { AnchorHTMLAttributes } from 'react';
import posthog from 'posthog-js';

interface TrackedSignUpLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  location: string;
}

export const TrackedSignUpLink = forwardRef<HTMLAnchorElement, TrackedSignUpLinkProps>(
  function TrackedSignUpLink({ location, onClick, ...props }, ref) {
    return (
      <a
        {...props}
        ref={ref}
        onClick={(event) => {
          posthog.capture('signup_cta_clicked', { location });
          onClick?.(event);
        }}
      />
    );
  },
);
